import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { distinctUntilChanged, startWith, map, tap, filter } from 'rxjs/operators';

export enum TailwindWidths {
  xs= 320,
  sm= 480,
  md= 768,
  tablet= 991,
  lg= 1200
}

@Injectable()
export class BreakpointNotifier {
  // private screenWidths = ScreenWidths;
  private viewportMode$: BehaviorSubject<any> = new BehaviorSubject(null);
  public currentScreen: string | undefined;

  constructor() { }

  init(): void {
    const obs = fromEvent(window, 'resize')
      .pipe(
        map(() => window.innerWidth),
        distinctUntilChanged(),
        filter((width: any) => width && width >= 320), //320px is iphone 4, all others are bigger
        startWith(window.innerWidth),
        tap(width => this.setBreakPoint(width)),
      );
    obs.subscribe(() => { });
  }

  setBreakPoint(width: any): void {
    this.applyCurrentScreen(width, TailwindWidths.xs+1, TailwindWidths.sm, 'xs');
    this.applyCurrentScreen(width, TailwindWidths.sm, TailwindWidths.md, 'sm');
    this.applyCurrentScreen(width, TailwindWidths.md, TailwindWidths.tablet, 'md');
    this.applyCurrentScreen(width, TailwindWidths.tablet, TailwindWidths.lg, 'tablet');
    if ((width >= TailwindWidths.lg) && this.currentScreen !== 'lg') {
      this.currentScreen = 'lg';
      this.viewportMode$.next(this.currentScreen);
    }
  }

  private applyCurrentScreen(width: number, minWidth: number, maxWidth: number, screenType: string) {
    if ((width >= minWidth && width < maxWidth) && this.currentScreen !== screenType) {
      this.currentScreen = screenType;
      this.viewportMode$.next(this.currentScreen);
    }
  }

  getBreakpoint(): BehaviorSubject<any> {
    return this.viewportMode$;
  }

}
